import styled from 'styled-components'
import { Body } from '@shipt/design-system-typography'
import { type Surface } from '@shipt/design-system-themes'

type Sides = 'right' | 'left'
type Props = {
  value: number
  ariaContext?: string
  corner?: Sides
  children?: React.ReactNode
  'aria-label'?: string
  className?: string
  surface?: Surface
}

export const NotificationBadge = ({
  value,
  ariaContext = '',
  corner = 'right',
  'aria-label': attrAriaLabel,
  children,
  className,
  surface = 'default',
}: Props) => {
  const ariaLabel = attrAriaLabel || `${value}${ariaContext.length > 0 ? ` in ${ariaContext}` : ''}`

  return (
    <NotificationContainer>
      {children}
      {value > 0 && (
        <Indicator
          size="sm"
          strong
          align="center"
          value={value}
          data-corner={corner}
          surface={surface}
          aria-live="polite"
          aria-label={ariaLabel}
          className={className}
          as="span"
        >
          {value}
        </Indicator>
      )}
    </NotificationContainer>
  )
}

const NotificationContainer = styled.div`
  position: relative;
  display: inline-block;
`

export const Indicator = styled(Body)<{
  'data-corner': Sides
  value: number
}>`
  position: absolute;
  top: -0.375rem;

  &[data-corner='left'] {
    left: -0.625rem;
  }

  &[data-corner='right'] {
    right: -0.625rem;
  }

  height: 1.25rem;
  min-width: ${({ value }) => (value > 9 ? '1.5625rem' : '1.25rem')};
  border-radius: ${({ value }) => (value > 9 ? '10px' : '100%')};
  padding: 0 ${({ value }) => (value > 99 ? '2px' : '0')} 0;
  background-color: ${({ theme, surface }) =>
    surface === 'inverse'
      ? theme.color.background.base.neutral.inverse
      : theme.color.background.base.brand.secondary_loud};
`
